export default __webpack_public_path__ + "0244320e0cdfb72d80630d0c6f3b36f6.png";